// extracted by mini-css-extract-plugin
module.exports = {"LoginButton":"ForgotPasswordConfirmSuccess_LoginButton__1XzUD"};